import { useFormik } from 'formik';
import { useMemo, useState } from 'react';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { TwoSelections } from 'views/mutual/inputRadio';
import { CardLabel, QuestionCard } from 'views/mutual/questionCard';
import { IGroupYesOrNoQuestion } from 'views/pages/compatibilityCheck/hooks';

type GroupYesOrNoQuestionPageProps = {
  question: IGroupYesOrNoQuestion;
  initialAnswer: Array<boolean> | null;
  onSubmit: (yesOrNos: Array<boolean>) => void;
  backQuestion: () => void;
};

type GroupYesOrNoInput = {
  yesOrNos: Array<boolean | null>;
};

const validate = (input: GroupYesOrNoInput) => {
  const errors = {} as { yesOrNos: string[] };

  const yesOrNosError = input.yesOrNos.map((yesOrNo) => (yesOrNo === null ? '選択してください' : ''));
  if (yesOrNosError.some((x) => !!x)) {
    errors.yesOrNos = yesOrNosError;
  }

  return errors;
};

export const GroupYesOrNoQuestionPage = (props: GroupYesOrNoQuestionPageProps) => {
  const initialValues = useMemo<GroupYesOrNoInput>(() => {
    if (props.initialAnswer) {
      return { yesOrNos: props.initialAnswer };
    } else {
      return { yesOrNos: props.question.questionTexts.map((_) => null) };
    }
  }, [props.question, props.initialAnswer]);

  // enableReinitialize: trueにすることで同じGroupYesOrNoの質問が続いても前の値が残らないようにしている
  const formik = useFormik<GroupYesOrNoInput>({
    initialValues,
    enableReinitialize: true,
    onSubmit: (input: GroupYesOrNoInput) => props.onSubmit(input.yesOrNos.map((x) => x || false)),
    validate,
    validateOnBlur: false,
    validateOnChange: true, //trueにしてerrorでformik.submitCount > 0を見ることで変更時にエラーを解消する
  });

  return (
    <>
      <div className="compatibilityCheck">
        {props.question.questionTexts.map((questionText, index) => (
          <QuestionCard
            key={index}
            topChildren={<CardLabel letter={questionText} />}
            bottomChildren={
              <TwoSelections
                name={`question_${index}`}
                selected={formik.values.yesOrNos[index]}
                onChange={(value) => formik.setFieldValue(`yesOrNos.${index}`, value)}
                error={formik.submitCount > 0 && formik.errors.yesOrNos ? formik.errors.yesOrNos![index] : undefined}
              />
            }
          />
        ))}
        <div className="compatibilityCheck_buttons">
          <Button
            type={ButtonType.Submit}
            label="次へ"
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            onClick={formik.handleSubmit}
          />
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={props.backQuestion}
          />
        </div>
      </div>
    </>
  );
};
